<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <place-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import PlaceForm from "./Form"
import model from "./model"

export default {
  components: { PlaceForm },
  data() {
    return { model }
  },
}
</script>
